import { useOutletContext } from 'react-router-dom';

/**
 * Values the service plan dashboard hands to its tab routes.
 *
 * Kept out of the dashboard component file so that file only exports components — the
 * react-refresh lint rule requires it, and it keeps fast refresh working.
 */
export type ServicePlanTabContext = {
    isServicePlanActive?: boolean;
};

export const useServicePlanTabContext = (): ServicePlanTabContext => useOutletContext<ServicePlanTabContext>();
